'use client';

import { Squircle } from 'lucide-react';
import { useThemeColor } from '@/hooks/useThemeColor';
import { backgroundColor } from '@/constants/constants';
import IconAdaptive from '@/components/IconAdaptive';

export default function HeaderMenu() {
    const { setScheme } = useThemeColor();
    return (
        <div className="flex flex-wrap items-center w-full max-w-full">
            {backgroundColor
                .filter((color) => color.bg !== 'bg-color-theme-default')
                .map((color) => (
                    <div key={color.bg} className=" pr-8 pb-4">
                        <IconAdaptive
                            Icon={Squircle}
                            strokeWidth={1.5}
                            baseSize={20}
                            fill="currentColor"
                            className={`${color.text} cursor-pointer`}
                            onClick={() => setScheme(color)}
                        />
                    </div>
                ))}
        </div>
    );
}
